import { Checkbox, CheckboxProps, FormControlLabel, Theme, SxProps } from '@mui/material';

interface CheckboxInputProps extends CheckboxProps {
    isModified?: boolean;
    label: React.ReactNode;
    formControlLabelSx?: SxProps<Theme>;
}

export default function CheckboxInput({
    checked,
    onChange,
    isModified = false,
    label,
    className = '',
    formControlLabelSx,
    ...props
}: CheckboxInputProps) {
    const mergedClassName = `${className} ${isModified ? 'modified' : ''}`.trim();

    return (
        <FormControlLabel
            className={mergedClassName}
            control={<Checkbox {...props} checked={checked} onChange={onChange} />}
            label={label}
            sx={formControlLabelSx}
        />
    );
}
